export default function init(handler) {
  handler.mock.onPost(/\/v1\/auth\/login/).reply(
    200,
    JSON.stringify({
      msg: 'OK',
      code: 200,
      data: {
        token: {
          token: '129ae21e312312d3fdcb123d21badd2gs84t98e8feeb',
          expire: 128376121,
          revoked: false,
          user: {
            username: 'admin',
            business: {
              id: 1,
              code: 565461,
              name: "حسین",
              business_type_id: 1,
              agent_id: 1,
              registration_number: 1,
              economic_code: 1,
              email: "h.naseri1990@gmail.com",
              status: 1,
              address_id: 2,
              address: {
                id: 2,
                address: "تهران، خیابان نصرت نرسیده به فرصت بقل دست چمران نرسیده به خیابان آزادی",
                postal_code: 11111111111,
                location_id: 2,
                email: "hoseinnaseri@gmail.com",
                location: {
                  id: 2,
                  lat: 28.54,
                  lng: 15.06,
                  created_at: "2018-11-18T23:48:55.484435+03:30",
                  updated_at: "2018-11-18T23:48:55.49363+03:30",
                },
                created_at: "2018-11-18T23:48:55.486047+03:30",
                updated_at: "2018-11-18T23:48:55.494639+03:30",
                deleted_at: "2018-11-18T23:48:55.494639+03:30",
              },
              created_at: "2018-12-05T13:49:34.627247+03:30",
              updated_at: "2018-12-05T13:49:34.627247+03:30",
              deleted_at: null,
            },
          }
        }
      }
    })
  )

  handler.mock.onGet(/\/v1\/auth\/logout/).reply(
    200,
    JSON.stringify({
      msg: 'OK',
      code: 200,
      data: {
        message: 'success'
      }
    })
  )

  handler.mock.onGet(/\/v1\/auth\/authorize/).reply(
    200,
    JSON.stringify({
      msg: 'OK',
      code: 200,
      data: {
        user: {
          username: 'admin',
          business: {
            id: 1,
            code: 565461,
            name: "حسین",
            business_type_id: 1,
            agent_id: 1,
            registration_number: 1,
            economic_code: 1,
            email: "h.naseri1990@gmail.com",
            status: 1,
            address_id: 2,
            address: {
              id: 2,
              address: "تهران، خیابان نصرت نرسیده به فرصت بقل دست چمران نرسیده به خیابان آزادی",
              postal_code: 11111111111,
              location_id: 2,
              email: "hoseinnaseri@gmail.com",
              location: {
                id: 2,
                lat: 28.54,
                lng: 15.06,
                created_at: "2018-11-18T23:48:55.484435+03:30",
                updated_at: "2018-11-18T23:48:55.49363+03:30",
              },
              created_at: "2018-11-18T23:48:55.486047+03:30",
              updated_at: "2018-11-18T23:48:55.494639+03:30",
              deleted_at: "2018-11-18T23:48:55.494639+03:30",
            },
            created_at: "2018-12-05T13:49:34.627247+03:30",
            updated_at: "2018-12-05T13:49:34.627247+03:30",
            deleted_at: null,
          },
        }
      }
    })
  )

  handler.mock.onPut(/\/v1\/auth\/password\/reset/).reply(
    200,
    JSON.stringify({
      msg: 'OK',
      code: 200,
      data: {
        message: 'success'
      }
    })
  )
}
